app.controller('baseVisitCardController', ['$rootScope', '$interval', '$scope', 'config', '$timeout', '$state',
    '$stateParams', '$mdDialog', '$mdMenu', '$translate', 'visitCardModel', 'userModel', 'referralToClinicModel',
    function ($rootScope, $interval, $scope, config, $timeout, $state, $stateParams, $mdDialog, $mdMenu, $translate,
              visitCardModel, userModel, referralToClinicModel) {
        setActions();

        function setActions() {
            $scope.openMedicalTemplatePopup = function(prescriptionType) {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/activeVisit/popup-prescription.html',
                    controller: 'popupPrescriptionController',
                    autoWrap: false,
                    resolve: {
                        prescriptionData: function() {
                            return null;
                        },
                        visitCardData: function(){
                            return $scope.visit;
                        },
                        patientData: function() {
                            return angular.copy($scope.$parent.patient);
                        },
                        prescriptionType: function() {
                            return prescriptionType;
                        },
                        previewOnly: function() {
                            return ($scope.visit.visitStatus === Enum.VISIT_STATUS.COMPLETED);
                        }
                    }
                }).then(function(updatedPrescriptionWrapper) {
                    visitCardModel.getById($scope.visitCard.id).then(function (visitCard) {
                        _.extend($scope.visitCard, visitCard);
                    });

                }, function(error){

                });
            };

            $scope.openMedicalTemplatePreviewPopup = function(prescriptionData) {
                if(!prescriptionData.p1Prescription) {
                    $('body').addClass('double-backdrop-body-wrapper');
                    var index = $scope.visitCard.prescriptions.indexOf(prescriptionData);
                    $mdDialog.show({
                        templateUrl: 'edm/application/view/app/patient/popup/activeVisit/popup-prescription.html',
                        controller: 'popupPrescriptionController',
                        autoWrap: false,
                        resolve: {
                            prescriptionData: function() {
                                return prescriptionData;
                            },
                            visitCardData: function() {
                                return $scope.visit;
                            },
                            patientData: function() {
                                return angular.copy($scope.$parent.patient);
                            },
                            prescriptionType: function() {
                                return null;
                            },
                            previewOnly: function() {
                                return ($scope.visit.visitStatus === Enum.VISIT_STATUS.COMPLETED);
                            }
                        }
                    }).then(function(editedPrescriptionData) {
                        visitCardModel.getById($scope.visitCard.id).then(function (visitCard) {
                            _.extend($scope.visitCard, visitCard);
                        });
                        $('body').remove('double-backdrop-body-wrapper');
                    }, function(error){
                        $('body').remove('double-backdrop-body-wrapper');
                    });
                } else {
                    $scope.showTestEPrescription(prescriptionData.id);
                }

            };

            $scope.showTestEPrescription = function (id) {
                visitCardModel.getP1ById(id).then(
                    function(prescriptionHTML) {
                        $mdDialog.show({
                            template: prescriptionHTML,
                            clickOutsideToClose: true
                        });
                    }
                );
            };

            $scope.showEReferral = function (id, fullVersion) {
                visitCardModel.getEReferralById(id, fullVersion).then(
                    function(referralHTML) {
                        $mdDialog.show({
                            template: referralHTML,
                            clickOutsideToClose: true
                        });
                    }
                );
            };

            $scope.printEReferral = function (id, fullVersion) {
                visitCardModel.getEReferralById(id, fullVersion).then(
                    function(referralHTML) {
                        var newWindow = window.open();
                        newWindow.document.body.innerHTML = referralHTML;
                        newWindow.focus();
                        newWindow.print();
                    });
            };

            $scope.deleteEReferral = function (id) {
                var confirm = $mdDialog.confirm({
                    title: $translate.instant('Czy na pewno chcesz usunąć e-skierowanie ?'),
                    ok: $translate.instant('T.UI.APPLICATION.YES'),
                    cancel: $translate.instant('T.UI.APPLICATION.NO')
                });
                $mdDialog.show(confirm).then(function() {

                    var configPopup = {
                        templateUrl: 'edm/application/view/app/patient/popup/activeVisit/popup-sign-prescription.html',
                        controller: 'popupSignPrescriptionController',
                        controllerAs: 'signPrescriptionCtrl',
                        skipHide: true,
                        locals: {
                            $scope: $scope,
                            $mdDialog: $mdDialog,
                            title: 'Podpisz receptę certyfikatem ZUS',
                            message: 'Podaj hasło do certyfikatu',
                            altButtons: false
                        }
                    };

                    $mdDialog.show(configPopup).then(function(password) {
                        if(password) {
                            visitCardModel.deleteEReferral(id, password).then(function() {
                                $state.reload();
                            });
                        }
                    });
                });
            };

            $scope.deleteExternalEReferral = function (id) {
                var confirm = $mdDialog.confirm({
                    title: $translate.instant('Czy na pewno chcesz usunąć e-skierowanie ?'),
                    ok: $translate.instant('T.UI.APPLICATION.YES'),
                    cancel: $translate.instant('T.UI.APPLICATION.NO')
                });
                $mdDialog.show(confirm).then(function() {
                    visitCardModel.deleteEReferral(id, null).then(function() {
                        $state.reload();
                    });
                });
            };

            //fixme skrócić do funkcji z templatką
            $scope.openReferralPopup = function(referral, referralType, previewOnly) {
                if($scope.visitCard.diagnosisList.length <= 0 && referralType !== Enum.REFERRAL_TYPE.LABORATORY
                    && referralType !== Enum.REFERRAL_TYPE.ALAB && referralType !== Enum.REFERRAL_TYPE.E_REFERRAL) {
                    $scope.alert(null, $translate.instant('T.MODULE.VISIT.NO_DIAGNOSIS_ADDED'));
                    return false;
                }

                var template = null;
                switch(referralType) {
                    case Enum.REFERRAL_TYPE.E_REFERRAL:
                        template = 'edm/application/view/app/patient/popup/activeVisit/popup-e-referral.html';
                        break;
                    case Enum.REFERRAL_TYPE.SPECIALIST:
                        template = 'edm/application/view/app/patient/popup/activeVisit/popup-specialist-referral.html';
                        break;
                    case Enum.REFERRAL_TYPE.HOSPITAL:
                        template = 'edm/application/view/app/patient/popup/activeVisit/popup-hospital-referral.html';
                        break;
                    case Enum.REFERRAL_TYPE.DIAGNOSTIC:
                        template = 'edm/application/view/app/patient/popup/activeVisit/popup-diagnostic-referral.html';
                        break;
                    case Enum.REFERRAL_TYPE.LABORATORY:
                        template = 'edm/application/view/app/patient/popup/activeVisit/popup-laboratory-referral.html';
                        break;
                    case Enum.REFERRAL_TYPE.ALAB:
                        template = 'edm/application/view/app/patient/popup/activeVisit/popup-laboratory-alab-referral.html';
                        break;
                }

                $scope.activeVisitPopup = $mdDialog.show({
                    templateUrl: template,
                    controller: 'popupReferralController',
                    resolve: {
                        referral: function() {
                            return referral;
                        },
                        visitCard: function(){
                            return $scope.visit;
                        },
                        patient: function() {
                            return angular.copy($scope.$parent.patient);
                        },
                        diagnosis: function() {
                            return angular.copy($scope.visitCard.diagnosisList);
                        },
                        referralType: function() {
                            return referralType;
                        },
                        previewOnly: function() {
                            return (referral && referral.alreadyPrinted);
                        },
                        nfzContracts: function() {
                            return ($scope.nfzContracts);
                        }
                    }
                }).then(function(returnedObjectReferrals) {
                    visitCardModel.getById($scope.visitCard.id).then(function (visitCard) {
                        _.extend($scope.visitCard, visitCard);
                    });
                }, function(error){
                    $state.reload();
                });
            };

            $scope.openSickLeavePopup = function () {
                if(!$scope.visitCard.sickLeave) {
                    if($scope.visitCard.diagnosisList.length <= 0) {
                        $scope.alert(null, $translate.instant('T.MODULE.VISIT.NO_DIAGNOSIS_ADDED'));
                        return;
                    }

                    var mainDiagnosis = $scope.visitCard.diagnosisList.filter(function (diagnosis) {
                        return  diagnosis.mainAffliction;
                    })[0];
                }


                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/activeVisit/popup-sickleave.html',
                    controller: 'popupSickLeaveController',
                    resolve: {
                        sickLeave: function () {
                            return $scope.visitCard.sickLeave;
                        },
                        mainDiagnosis: function () {
                            return mainDiagnosis;
                        },
                        visit: function () {
                            return $scope.visit;
                        },
                        previewOnly: function() {
                            return ($scope.visit.visitStatus === Enum.VISIT_STATUS.COMPLETED);
                        }
                    }
                }).then(function(sickLeave) {
                    visitCardModel.getById($scope.visitCard.id).then(function (visitCard) {
                        _.extend($scope.visitCard, visitCard);
                    });
                }, function(error){
                    //
                });
            };

            $scope.openHeartEchoPopup = function () {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/popup-heart-echo.html',
                    controller: 'popupHeartEchoController',
                    resolve: {
                        patient: function() {
                            return angular.copy($scope.$parent.patient);
                        },
                        visitCardData: function() {
                            return $scope.visit;
                        }
                    }
                }).then(function(returnedObjectReferrals) {
                    visitCardModel.getById($scope.visitCard.id).then(function (visitCard) {
                        _.extend($scope.visitCard, visitCard);
                    });
                }, function(error){
                    visitCardModel.getById($scope.visitCard.id).then(function (visitCard) {
                        _.extend($scope.visitCard, visitCard);
                    });
                });
            };

            $scope.openReferralToClinicPopup = function () {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/popup-referral-to-clinic.html',
                    controller: 'popupReferralToClinicController',
                    resolve: {
                        patient: function() {
                            return angular.copy($scope.$parent.patient);
                        },
                        visitCardData: function() {
                            return $scope.visit;
                        }
                    }
                }).then(function(returnedObjectReferrals) {
                    visitCardModel.getById($scope.visitCard.id).then(function (visitCard) {
                        _.extend($scope.visitCard, visitCard);
                    });
                }, function(error){
                    visitCardModel.getById($scope.visitCard.id).then(function (visitCard) {
                        _.extend($scope.visitCard, visitCard);
                    });
                });
            };

            $scope.getClinicReferralPDF = function (id, print) {
                referralToClinicModel.getPDF(id).then(function(link) {
                    var clinicReferralPreview = window.open(link, '_blank');
                    clinicReferralPreview.focus();
                    if (print) {
                        clinicReferralPreview.print();
                    }
                });

            };
        }
    }
]);
